import React from 'react';
import { Star, ShieldCheck, Wrench, Award, Crosshair, MapPin } from 'lucide-react';
export function Reviews() {
  const reviews = [{
    quote: '[Paste real customer review here.]',
    name: '[Customer Name]',
    location: '[City]',
    label: 'Auto Glass Customer'
  }, {
    quote: '[Paste real customer review here.]',
    name: '[Customer Name]',
    location: '[City]',
    label: 'Windshield Replacement'
  }, {
    quote: '[Paste real customer review here.]',
    name: '[Customer Name]',
    location: '[City]',
    label: 'Insurance Claim'
  }];
  const stats = [{
    icon: <ShieldCheck className="w-5 h-5 text-brand-blue" data-id="element-355" />,
    label: 'Family-Owned Since 2000'
  }, {
    icon: <Wrench className="w-5 h-5 text-brand-blue" data-id="element-356" />,
    label: 'Certified Auto Glass Technicians'
  }, {
    icon: <Award className="w-5 h-5 text-brand-blue" data-id="element-357" />,
    label: 'Lifetime Workmanship Warranty'
  }, {
    icon: <Crosshair className="w-5 h-5 text-brand-blue" data-id="element-358" />,
    label: 'ADAS Calibration In-House'
  }, {
    icon: <MapPin className="w-5 h-5 text-brand-blue" data-id="element-359" />,
    label: 'Howell, Ann Arbor & Novi'
  }];
  return <section className="py-16 lg:py-24 bg-slate-50 border-t border-slate-200" aria-labelledby="reviews-heading" data-id="element-360">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-361">
        <div className="text-center max-w-3xl mx-auto mb-14" data-id="element-362">
          <div className="inline-flex items-center gap-1 mb-4 text-amber-500" aria-hidden="true" data-id="element-363">
            <Star className="w-5 h-5 fill-current" data-id="element-364" />
            <Star className="w-5 h-5 fill-current" data-id="element-365" />
            <Star className="w-5 h-5 fill-current" data-id="element-366" />
            <Star className="w-5 h-5 fill-current" data-id="element-367" />
            <Star className="w-5 h-5 fill-current" data-id="element-368" />
          </div>
          <h2 id="reviews-heading" className="text-3xl md:text-4xl font-bold text-navy-900 mb-4" data-id="element-369">
            What Customers Say About Kosin's Glass
          </h2>
          <p className="text-lg text-slate-600 leading-relaxed" data-id="element-370">
            Local drivers count on Kosin's Glass for windshield replacement,
            auto glass repair, insurance help and professional installation.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12" data-id="element-371">
          {reviews.map((review, i) => <article key={i} className="bg-white rounded-2xl p-7 border border-slate-100 shadow-sm hover:shadow-md transition-shadow scroll-fade-up" style={{
          animationDelay: `${i * 0.08}s`
        }} aria-label={`5-star review from ${review.name}`} data-id="element-372">
              <div className="flex items-center gap-0.5 mb-4 text-amber-500" aria-hidden="true" data-id="element-373">
                <Star className="w-4 h-4 fill-current" data-id="element-374" />
                <Star className="w-4 h-4 fill-current" data-id="element-375" />
                <Star className="w-4 h-4 fill-current" data-id="element-376" />
                <Star className="w-4 h-4 fill-current" data-id="element-377" />
                <Star className="w-4 h-4 fill-current" data-id="element-378" />
              </div>
              <span className="sr-only" data-id="element-379">5-star review</span>
              <blockquote className="text-slate-700 leading-relaxed italic mb-5" data-id="element-380">
                "{review.quote}"
              </blockquote>
              <footer className="pt-4 border-t border-slate-100" data-id="element-381">
                <p className="font-bold text-navy-900 not-italic" data-id="element-382">
                  {review.name}
                </p>
                <p className="text-sm text-slate-500 not-italic" data-id="element-383">
                  {review.location}
                </p>
                <p className="inline-block mt-2 px-2.5 py-0.5 rounded-md bg-brand-light text-brand-blue text-xs font-semibold" data-id="element-384">
                  {review.label}
                </p>
              </footer>
            </article>)}
        </div>

        <div className="bg-white rounded-2xl border border-slate-200 shadow-sm px-6 py-5" data-id="element-385">
          <ul className="flex flex-wrap justify-center items-center gap-x-6 gap-y-3" data-id="element-386">
            {stats.map((stat, i) => <li key={i} className="flex items-center gap-2 text-sm font-medium text-navy-900" data-id="element-387">
                {stat.icon}
                <span data-id="element-388">{stat.label}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}